import { React } from 'react';
import Axios from 'axios';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { calculateAge, emailRegex, formatPhoneNumber, logout, setAuthToken } from '../common';
import PmsUrlConfig from '../../urlConfig';
import BasicUserSettings from './BasicUserSettings';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from "react-router-dom";
import ErrorMessages from '../../errorConfig';
import pmsConstants from '../../pmsConstants';
import PatientAppointmentDetails from '../AppointmentRequestPage/PatientDetails';

export default function PatientBasicUserSettings() {
    const practiceDetails = useSelector(state => state.practiceDetails);
    const loginDetails = useSelector(state => state.loginDetails);
    const dispatch = useDispatch();
    if (!practiceDetails)
        <Navigate replace to={`${PmsUrlConfig.LOGIN_URL}`} />

    var loggedInUser = null;
    var userType = "";
    var token = "";
    if (loginDetails != null) {
        loggedInUser = loginDetails.loggedInUser;
        userType = loggedInUser.user_type;
        token = loginDetails.jwtToken;
    }

    const BasicDetailsSchema = Yup.object().shape({
        firstname: Yup.string().required(ErrorMessages.FIRSTNAME_REQUIRED),
        lastname: Yup.string().required(ErrorMessages.LASTNAME_REQUIRED),
        userEmail: Yup.string()
            .required(ErrorMessages.EMAIL_REQUIRED)
            .matches(emailRegex, ErrorMessages.EMAIL_INVALID),
        phoneNo: Yup.string().required(ErrorMessages.PHONE_NUM_REQUIRED),
        apptZipcode: Yup.string()
            .matches(/^[0-9]+$/, "Must be only digits")
            .min(5, "Must be exactly 5 digits")
            .max(5, "Must be exactly 5 digits"),
        age: Yup.number()
            .required("Please select a valid Date of Birth")
            .min(18, "You must be at least 18 years"),
    })
    var formattedPhoneNum = "";
    formattedPhoneNum = formatPhoneNumber(loggedInUser.phoneNum);
    const successMsg = practiceDetails.successMsg;
    const errorMsg = practiceDetails.errorMsg;
    const handleSearchRadiusChange = (e, setFieldValue) => {
        setFieldValue('searchRadius', e.target.value);
    }
    return (
        <div>
            <Formik
                initialValues={{
                    firstname: loggedInUser.firstname,
                    lastname: loggedInUser.lastname,
                    username: loggedInUser.username,
                    userEmail: loggedInUser.email,
                    phoneNo: formattedPhoneNum,
                    apptZipcode: loggedInUser.zip_code,
                    searchRadius: loggedInUser.search_radius_miles,
                    apptInsurance: loggedInUser.insurance,
                    age: calculateAge(new Date(loggedInUser.dateOfBirth)),
                    gender: loggedInUser.gender,
                    dateOfBirth: loggedInUser.dateOfBirth
                }}
                validationSchema={BasicDetailsSchema}
                onSubmit={(values, { setSubmitting }) => {
                    var userUpdateObj;
                    var editUserUrl = PmsUrlConfig.BOS_EDIT_PATIENT_PROFILE_URL;
                    userUpdateObj = {
                        _id: loggedInUser._id,
                        firstname: values.firstname,
                        lastname: values.lastname,
                        gender: values.gender,
                        age: parseInt(values.age),
                        email: values.userEmail,
                        phoneNum: values.phoneNo.replace(/[^\d]/g, ''),
                        username: values.username,
                        password: loggedInUser.password,
                        password_confirm: loggedInUser.password,
                        zip_code: values.apptZipcode,
                        search_radius_miles: parseInt(values.searchRadius),
                        insurance: values.apptInsurance,
                        user_type: loggedInUser.user_type,
                        dateOfBirth: values.dateOfBirth
                    }

                    setAuthToken(token);
                    Axios.patch(editUserUrl, userUpdateObj
                    ).then((response) => {
                        if (response.status === 200) {

                            dispatch({
                                type: 'basicSettingsUpdateSuccess',
                                payload: response.data
                            })
                            dispatch({
                                type: 'loginSuccess',
                                payload: response.data
                            })
                            setSubmitting(false);
                        }
                        else if (response.status === 400) {
                            console.log("STATUS 400:", response)
                            setSubmitting(false);
                        }
                        else if (response.status === 401 || response.status === 403) {
                            logout();
                            //TODO: Redirect to login page
                        }
                    }).catch((error) => {
                        console.log("ERROR:", error)
                        setSubmitting(false);
                    })
                }}

            >
                {({ errors, touched, values, handleChange, setFieldValue, handleBlur, isSubmitting }) => (
                    <Form id="update_basic_settings_form">
                        <div className="w-full max-w-4xl">
                            {successMsg && <div className='mb-4 p-3 text-green-800 bg-green-100 rounded border border-green-200'>{successMsg}</div>}
                            {errorMsg && <div className='mb-4 p-3 text-red-800 bg-red-100 rounded border border-red-200'>{errorMsg}</div>}
                            <BasicUserSettings
                                errors={errors}
                                touched={touched}
                                values={values}
                                handleBlur={handleBlur}
                                handleChange={handleChange}
                                setFieldValue={setFieldValue}
                                isEditPage="true"
                                userType={userType}
                                patientEdit={userType === pmsConstants.USER_TYPE_PATIENT}
                            />
                            {userType === pmsConstants.USER_TYPE_PATIENT &&
                                <PatientAppointmentDetails
                                    errors={errors}
                                    touched={touched}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    setFieldValue={setFieldValue}
                                    handleSearchRadiusChange={handleSearchRadiusChange}
                                    values={values}
                                />}
                            <div className="mt-6">
                                <button 
                                    type="submit" 
                                    disabled={isSubmitting}
                                    className="px-6 py-2 h-10 bg-gradient-to-r from-[#0B6D76] to-[#09757F] text-white font-semibold rounded-lg shadow-lg hover:from-[#095C64] hover:to-[#0A6B73] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0B6D76] transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
}

